import { Dispatch, SetStateAction } from 'react'
import { ILoanInitCalculate } from '../../../service/LoanInitService'
import {ILoanCalculatorState, PREDEFINED_PERIODS_OFFER_LOGIC, SliderStep} from '../../../store/types'

export enum LoanCalculatorSlidersTypes {
   amount = 'amount',
   period = 'period',
}

export enum LOAN_CALCULATOR_PREDEFINED_PERIODS {
   SHORT = "SHORT",
   LONG = "LONG"
}


export interface ILoanCalculatorEditableProps {
   loanCalculatorStateParams: ILoanCalculatorState;
   isLoading: boolean;
   handleOnPredefinedPeriodButtonClick: (newSelectedPeriod: PREDEFINED_PERIODS_OFFER_LOGIC) => Promise<void>
   onLoanValueSliderUpdate: (newSliderValue: number, type: LoanCalculatorSlidersTypes) => Promise<void>
   handleOnClose: () => void;
   onValueChanged: () => void;
}
export interface ILoanCalculatorReadOnlyProps {
   handleOnClose: () => void;
}

export interface ILoanCalculatorProps {
   isOpenOnMount?: boolean;
}

export interface ILoanCalculatorOffertSummaryProps {
   offert: ILoanCalculatorState,
   isLoading: boolean;
   // textContent: (key: string) => string,
}

export interface LoanCalculatorSlidersProps {
   steps: SliderStep[];
   min: number;
   max: number;
   type: LoanCalculatorSlidersTypes;
   headerText: string;
   currentSliderValue: number;
   onLoanValueSliderUpdate: (newSliderValue: number, type: LoanCalculatorSlidersTypes) => Promise<void>
   onValueChanged: () => void
}

export interface LoanCalculatorLoanPredefinedPeriodButtonProps {
   instalment: number;
   isCurrentSelected: boolean;
   handleOnLoanInstalmentButtonClick: (e: React.MouseEvent) => void 
}

export interface LoanCalculatorManualChooseInstalmentProps {
   instalmentAmount: number;
   handleOnPredefinedPeriodButtonClick: (newSelectedPeriod: PREDEFINED_PERIODS_OFFER_LOGIC) => Promise<void>
}